// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FeedbackModal-cls1___bb751821e434cfb0829{/*!*/}.FeedbackModal-cls2__c9414bf9c48fa6644955{display:flex;flex-wrap:nowrap;grid-gap:16px;gap:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "FeedbackModal-cls1___bb751821e434cfb0829",
	"cls2": "FeedbackModal-cls2__c9414bf9c48fa6644955 FeedbackModal-cls1___bb751821e434cfb0829"
};
export default ___CSS_LOADER_EXPORT___;
